// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 24qDGfvb2rMn6oy8PVF95d
// Component: _2cTOMiaTn

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic_plasmic_rich_components.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import plasmic_pro_pro_css from "../pro_pro/plasmic_pro_pro.module.css"; // plasmic-import: qtWvXH8Uhh67sc1TY2MZeK/projectcss
import projectcss from "./plasmic_hub_hub.module.css"; // plasmic-import: 24qDGfvb2rMn6oy8PVF95d/projectcss
import sty from "./PlasmicHeaderOverlayMenu.module.css"; // plasmic-import: _2cTOMiaTn/css

import ClosesvgIcon from "./icons/PlasmicIcon__Closesvg"; // plasmic-import: ze_MFlDSdi/icon

createPlasmicElementProxy;

export type PlasmicHeaderOverlayMenu__VariantMembers = {};
export type PlasmicHeaderOverlayMenu__VariantsArgs = {};
type VariantPropType = keyof PlasmicHeaderOverlayMenu__VariantsArgs;
export const PlasmicHeaderOverlayMenu__VariantProps =
  new Array<VariantPropType>();

export type PlasmicHeaderOverlayMenu__ArgsType = {};
type ArgPropType = keyof PlasmicHeaderOverlayMenu__ArgsType;
export const PlasmicHeaderOverlayMenu__ArgProps = new Array<ArgPropType>();

export type PlasmicHeaderOverlayMenu__OverridesType = {
  root?: p.Flex<"div">;
  freeBox?: p.Flex<"div">;
  closeButton?: p.Flex<"button">;
  close?: p.Flex<"svg">;
  group232?: p.Flex<"div">;
  group267?: p.Flex<"div">;
  darkMode?: p.Flex<"div">;
  darkMode2?: p.Flex<"div">;
  group266?: p.Flex<"div">;
  eggshellMode?: p.Flex<"div">;
};

export interface DefaultHeaderOverlayMenuProps {
  className?: string;
}

const $$ = {};

function PlasmicHeaderOverlayMenu__RenderFunc(props: {
  variants: PlasmicHeaderOverlayMenu__VariantsArgs;
  args: PlasmicHeaderOverlayMenu__ArgsType;
  overrides: PlasmicHeaderOverlayMenu__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  return (
    <p.Stack
      as={"div"}
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      hasGap={true}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        plasmic_pro_pro_css.plasmic_tokens,
        sty.root
      )}
    >
      <div
        data-plasmic-name={"freeBox"}
        data-plasmic-override={overrides.freeBox}
        className={classNames(projectcss.all, sty.freeBox)}
      >
        <button
          data-plasmic-name={"closeButton"}
          data-plasmic-override={overrides.closeButton}
          className={classNames(
            projectcss.all,
            projectcss.button,
            sty.closeButton
          )}
          onClick={async event => {
            const $steps = {};
          }}
          ref={ref => {
            $refs["closeButton"] = ref;
          }}
        >
          <ClosesvgIcon
            data-plasmic-name={"close"}
            data-plasmic-override={overrides.close}
            className={classNames(projectcss.all, sty.close)}
            role={"img"}
          />
        </button>
      </div>
      <div
        className={classNames(
          projectcss.all,
          projectcss.__wab_text,
          sty.text__jeD0K
        )}
      >
        {"Resources"}
      </div>
      <div
        className={classNames(
          projectcss.all,
          projectcss.__wab_text,
          sty.text__kqK21
        )}
      >
        {"Send Feedback"}
      </div>
      <div
        className={classNames(
          projectcss.all,
          projectcss.__wab_text,
          sty.text__gUbr4
        )}
      >
        {"Manage Account"}
      </div>
      <div
        className={classNames(
          projectcss.all,
          projectcss.__wab_text,
          sty.text__wIbwc
        )}
      >
        {"Rename Hub"}
      </div>
      <div
        className={classNames(
          projectcss.all,
          projectcss.__wab_text,
          sty.text__yYrL0
        )}
      >
        {"Delete Hub "}
      </div>
      <div
        className={classNames(
          projectcss.all,
          projectcss.__wab_text,
          sty.text___7Ml2O
        )}
      >
        <React.Fragment>
          <React.Fragment>{"Go "}</React.Fragment>
          <span
            className={"plasmic_default__all plasmic_default__span"}
            style={{ color: "#D6455B" }}
          >
            {"Pro"}
          </span>
        </React.Fragment>
      </div>
      <p.PlasmicImg
        alt={""}
        className={classNames(sty.img__mNwO)}
        displayHeight={"auto"}
        displayMaxHeight={"none"}
        displayMaxWidth={"100%"}
        displayMinHeight={"0"}
        displayMinWidth={"0"}
        displayWidth={"122px"}
        loader={"plasmic"}
        loading={"lazy"}
        src={{
          src: "https://img.plasmic.app/img-optimizer/v1/img/c41bd7d26fa2ebf8306066f8a32c9a7b.png",
          fullWidth: 486,
          fullHeight: 142
        }}
      />

      <div
        data-plasmic-name={"group232"}
        data-plasmic-override={overrides.group232}
        className={classNames(projectcss.all, sty.group232)}
      >
        <div
          data-plasmic-name={"group267"}
          data-plasmic-override={overrides.group267}
          className={classNames(projectcss.all, sty.group267)}
        >
          <p.PlasmicImg
            alt={""}
            className={classNames(sty.img__n17Zd)}
            displayHeight={"41px"}
            displayMaxHeight={"none"}
            displayMaxWidth={"100%"}
            displayMinHeight={"0"}
            displayMinWidth={"0"}
            displayWidth={"108px"}
            loader={"plasmic"}
            loading={"lazy"}
            src={{
              src: "https://site-assets.plasmic.app/7abb8b92ea8089db6f754e04ec856278.svg",
              fullWidth: 108,
              fullHeight: 41,
              aspectRatio: 2.634146
            }}
          />

          <div
            data-plasmic-name={"darkMode"}
            data-plasmic-override={overrides.darkMode}
            className={classNames(projectcss.all, sty.darkMode)}
          >
            <div
              data-plasmic-name={"darkMode2"}
              data-plasmic-override={overrides.darkMode2}
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.darkMode2
              )}
            >
              {"Dark Mode "}
            </div>
          </div>
        </div>
        <div
          data-plasmic-name={"group266"}
          data-plasmic-override={overrides.group266}
          className={classNames(projectcss.all, sty.group266)}
        >
          <p.PlasmicImg
            alt={""}
            className={classNames(sty.img__cyjrd)}
            displayHeight={"41px"}
            displayMaxHeight={"none"}
            displayMaxWidth={"100%"}
            displayMinHeight={"0"}
            displayMinWidth={"0"}
            displayWidth={"105px"}
            loader={"plasmic"}
            loading={"lazy"}
            src={{
              src: "https://site-assets.plasmic.app/f7260f6ff6dc74b62182f7cadfbe7b98.svg",
              fullWidth: 105,
              fullHeight: 41,
              aspectRatio: 2.560976
            }}
          />

          <div
            data-plasmic-name={"eggshellMode"}
            data-plasmic-override={overrides.eggshellMode}
            className={classNames(projectcss.all, sty.eggshellMode)}
          >
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__f4MhQ
              )}
            >
              {"Eggshell Mode"}
            </div>
          </div>
        </div>
      </div>
    </p.Stack>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "freeBox",
    "closeButton",
    "close",
    "group232",
    "group267",
    "darkMode",
    "darkMode2",
    "group266",
    "eggshellMode"
  ],
  freeBox: ["freeBox", "closeButton", "close"],
  closeButton: ["closeButton", "close"],
  close: ["close"],
  group232: [
    "group232",
    "group267",
    "darkMode",
    "darkMode2",
    "group266",
    "eggshellMode"
  ],
  group267: ["group267", "darkMode", "darkMode2"],
  darkMode: ["darkMode", "darkMode2"],
  darkMode2: ["darkMode2"],
  group266: ["group266", "eggshellMode"],
  eggshellMode: ["eggshellMode"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  freeBox: "div";
  closeButton: "button";
  close: "svg";
  group232: "div";
  group267: "div";
  darkMode: "div";
  darkMode2: "div";
  group266: "div";
  eggshellMode: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicHeaderOverlayMenu__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicHeaderOverlayMenu__VariantsArgs;
    args?: PlasmicHeaderOverlayMenu__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicHeaderOverlayMenu__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicHeaderOverlayMenu__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicHeaderOverlayMenu__ArgProps,
          internalVariantPropNames: PlasmicHeaderOverlayMenu__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicHeaderOverlayMenu__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicHeaderOverlayMenu";
  } else {
    func.displayName = `PlasmicHeaderOverlayMenu.${nodeName}`;
  }
  return func;
}

export const PlasmicHeaderOverlayMenu = Object.assign(
  // Top-level PlasmicHeaderOverlayMenu renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    freeBox: makeNodeComponent("freeBox"),
    closeButton: makeNodeComponent("closeButton"),
    close: makeNodeComponent("close"),
    group232: makeNodeComponent("group232"),
    group267: makeNodeComponent("group267"),
    darkMode: makeNodeComponent("darkMode"),
    darkMode2: makeNodeComponent("darkMode2"),
    group266: makeNodeComponent("group266"),
    eggshellMode: makeNodeComponent("eggshellMode"),

    // Metadata about props expected for PlasmicHeaderOverlayMenu
    internalVariantProps: PlasmicHeaderOverlayMenu__VariantProps,
    internalArgProps: PlasmicHeaderOverlayMenu__ArgProps
  }
);

export default PlasmicHeaderOverlayMenu;
/* prettier-ignore-end */
